import React from "react";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "./Introduction.messages";
import styles from "./Introduction.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";

interface Introductions {
  title: string;
}

export const Introduction: React.FC<Introductions> = () => {
  const { formatMessage } = useIntl();

  return (
    <SimpleLayoutView>
      <div className={styles.introduction}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G4_P1_S1_Title)}</h3>

                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P1_S1_Description) }}></p>
                <div className={styles.thanks}>{formatMessage(messages.G4_P1_S1_Thanks)}</div>
              </div>,
              <div key={2} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G4_P1_S2_Title)}</h3>

                <ul className={styles.list}>
                  <li>{formatMessage(messages.G4_P1_S2_Item1)}</li>
                  <li>{formatMessage(messages.G4_P1_S2_Item2)}</li>
                  <li>{formatMessage(messages.G4_P1_S2_Item3)}</li>
                </ul>
              </div>,
              <div key={3} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G4_P1_S3_Title)}</h3>
                <ul className={styles.list}>
                  <li>{formatMessage(messages.G4_P1_S3_Item1)}</li>
                  <li>
                    {formatMessage(messages.G4_P1_S3_Item2)}
                    <ul className={styles.sublist}>
                      <li>{formatMessage(messages.G4_P1_S3_Item2_1)}</li>
                      <li>{formatMessage(messages.G4_P1_S3_Item2_2)}</li>
                    </ul>
                  </li>
                  <li>{formatMessage(messages.G4_P1_S3_Item3)}</li>
                  <li>{formatMessage(messages.G4_P1_S3_Item4)}</li>
                  <li>{formatMessage(messages.G4_P1_S3_Item5)}</li>
                </ul>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
